export default __webpack_public_path__ + "static/consumer-image-drift-db4161a185b1dbbc822150f3c0f7fca2.gif";